// Generado desde backend/api/data/utopie7/SIN_PELDANO.csv — no editar a mano.
export default {
  "4": {
    "17": {
      "4": "sólo pide RECONOCER figuras trasladadas: sin las figuras no queda nada que reconocer. Producir la transformación es 4º OA 18"
    },
    "2": {
      "3": "leer y representar números hasta 1.000"
    },
    "10": {
      "1": "el verbo ya es «resolver problemas»: arranca en el peldaño 3-4. Emparejar con 3º OA 07",
      "2": "el verbo ya es «resolver problemas»: arranca en el peldaño 3-4. Emparejar con 3º OA 07"
    }
  },
  "5": {
    "27": {
      "4": "leer e interpretar gráficos: los valores son arbitrarios y viven en el gráfico. Sin gráfico la tarea pasa a ser construirlo, que es otro OA"
    },
    "4": {
      "3": "propiedades del 0 y del 1: regla única"
    },
    "21": {
      "1": "conversión de unidades de tiempo: cualquier apoyo que se dibuje ya obliga a operar, así que no existe el peldaño de sólo localizar"
    },
    "7": {
      "1": "«resolver problemas seleccionando la operación». Emparejar con 4º OA 05",
      "2": "«resolver problemas seleccionando la operación». Emparejar con 4º OA 05"
    }
  },
  "7": {
    "24": {
      "4": "igual que 4º OA 27, con barra doble y circular"
    },
    "14": {
      "3": "teselados: identificar la transformación y continuarla"
    },
    "15": {
      "3": "clasificar y construir ángulos: sin inversión"
    },
    "2": {
      "1": "«en el contexto de la resolución de problemas»",
      "2": "«en el contexto de la resolución de problemas»"
    },
    "8": {
      "1": "«resolver problemas rutinarios y no rutinarios»",
      "2": "«resolver problemas rutinarios y no rutinarios»"
    }
  },
  "9": {
    "16": {
      "4": "evaluar cómo están presentados los datos: el objeto de la tarea ES el gráfico"
    },
    "5": {
      "1": "«resolver problemas que involucran variaciones porcentuales»",
      "2": "«resolver problemas que involucran variaciones porcentuales»"
    },
    "8": {
      "1": "«modelar situaciones de la vida diaria»",
      "2": "«modelar situaciones de la vida diaria»"
    }
  },
  "2": {
    "3": {
      "3": "leer y representar números: no hay procedimiento con entrada y salida que invertir"
    },
    "15": {
      "3": "identificar y dibujar líneas: nombrar o trazar, sin resultado que devolver"
    },
    "17": {
      "3": "secuenciar días y meses: no hay nada que invertir"
    }
  },
  "3": {
    "2": {
      "3": "leer y representar números hasta 100"
    },
    "8": {
      "3": "regla única (sumar 0): no hay inverso distinto del directo"
    },
    "14": {
      "3": "posición relativa — REVISAR: lo clasifiqué sin saber que existían silla_/auto_/mochila_ en cuatro orientaciones; con esos assets probablemente sí tiene peldaño 3"
    },
    "17": {
      "3": "identificar fechas en el calendario"
    }
  },
  "6": {
    "17": {
      "3": "describir aristas y caras: reconocimiento puro"
    },
    "20": {
      "1": "conversión de unidades de longitud, mismo motivo"
    },
    "6": {
      "1": "«resolver problemas rutinarios y no rutinarios». Emparejar con 5º OA 03",
      "2": "«resolver problemas rutinarios y no rutinarios». Emparejar con 5º OA 03"
    },
    "13": {
      "1": "el verbo es resolver problemas",
      "2": "el verbo es resolver problemas"
    },
    "15": {
      "1": "«resolver problemas usando ecuaciones». Emparejar con 5º OA 14",
      "2": "«resolver problemas usando ecuaciones». Emparejar con 5º OA 14"
    },
    "21": {
      "1": "arranca invertido: dados perímetro o área, hallar los lados",
      "2": "arranca invertido: dados perímetro o área, hallar los lados"
    }
  },
  "8": {
    "12": {
      "3": "construir bisectrices y alturas: identificar y trazar"
    },
    "5": {
      "1": "notación científica: puramente notacional"
    },
    "3": {
      "1": "«resolver problemas que involucren multiplicación y división»",
      "2": "«resolver problemas que involucren multiplicación y división»"
    },
    "9": {
      "1": "«modelar y resolver problemas»",
      "2": "«modelar y resolver problemas»"
    }
  }
};
